export default __webpack_public_path__ + "static/media/umum.547b315e.png";